<template>
  <div class="container-fluid" id="ahr-homepage">
    <div class="row">
      <div id="ahr-content" class="col-sm-9">
        <div class="row">
          <div class="col-sm-12">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_Website Stats.png" class="ahr-icon">
                WEBSITE STATS
              </h4>
              <div class="row">
                <div class="col-sm-4">
                  <NumberWidget :key="customKey" :widget="totalConversion" />
                </div>
                <div class="col-sm-4 custom-table">
                  <h5 class="text-center" id="traffic-src">TOP 5 TRAFFIC SOURCES</h5>
                  <TableWidget :key="customKey" :widget="topTrafficSources" />
                </div>
                <div class="col-sm-4">
                  <NumberWidget :key="customKey" :widget="newUsers" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_LeadData.png" class="ahr-icon">
                LEAD DATA
              </h4>
              <div class="row">
                <div class="col-sm-12">
                  <NumberWidget :key="customKey" :widget="totalLeads" />
                </div>
                <div class="col-sm-12">
                  <DoughnutWidget :key="customKey" :widget="leadBreakdown" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_Funnel.png" class="ahr-icon">
                FUNNEL
              </h4>
              <div class="row">
                <div class="col-sm-12">
                  <FunnelWidget :key="customKey" :widget="funnelData" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_Inventory.png" class="ahr-icon">
                INVENTORY LEVELS
              </h4>
              <NumberWidget :key="customKey" :widget="inventoryLevels" />
              <div class="col-sm-12 custom-table">
                <h5 class="text-center" id="top-models">TOP 5 VDP VIEWS</h5>
                <TableWidget :key="customKey" :widget="topModels" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_Attribution.png" class="ahr-icon">
                ATTRIBUTION
              </h4>
              <DoughnutWidget :key="customKey" :customData="customData" :widget="leadBreakdown" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_SEO.png" class="ahr-icon">
                SEO
              </h4>
              <NumberWidget :key="customKey" :widget="seoData" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="ahr-card">
              <h4>
                <img src="../../static/images/Mom-icons_PaidSocial.png" class="ahr-icon">
                PAID SOCIAL MEDIA
              </h4>
              <NumberWidget :key="customKey" :widget="paidSocialNumbers" />
            </div>
          </div>
        </div>
      </div>
      <div id="account-report" class="col-sm-3">
        <img class="center-block img-fluid" id="report-icon" src="../../static/images/Mom-icons_Dashboard.png">
        <h3 class="text-center">Key Takeaways<br>and<br>Recommendations</h3>
        <div class="underline"></div>
        <GalleryWidget :key="customKey" :widget="accountSummary" />
      </div>
    </div>
  </div>
</template>

<script>
import NumberWidget from "./widgets/NumberWidget"
import DoughnutWidget from "./widgets/DoughnutWidget"
import LinechartWidget from "./widgets/LinechartWidget"
import BarWidget from "./widgets/BarWidget"
import TableWidget from "./widgets/TableWidget"
import GaugeWidget from "./widgets/GaugeWidget"
import GalleryWidget from "./widgets/GalleryWidget"
import FunnelWidget from "./widgets/FunnelWidget"
export default {
  name: "CustomContent",
  components: {
    NumberWidget,
    DoughnutWidget,
    LinechartWidget,
    BarWidget,
    TableWidget,
    GaugeWidget,
    GalleryWidget,
    FunnelWidget
  },
  data() {
    return {
      customKey: 0,
      totalConversion: {
        id: 888,
        title: "Total Conv. Rate",
        widget_titles: [],
        type: "NumberWidget",
        dashboard_id: "33",
        x: 0,
        y: 0,
        w: 1,
        h: 2,
        shared: false,
        filters: [],
        options: {},
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [120],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false
      },
      topTrafficSources: {
        id: 891,
        title: "Top Traffic Sources",
        widget_titles: [],
        type: "TableWidget",
        dashboard_id: "33",
        x: 0,
        y: 2,
        w: 2,
        h: 5,
        shared: false,
        filters: [
          {
            filter_value: ["s3.amazonaws.com"],
            filter_condition: null,
            filter_inclusion: "exclude",
            filter_comparison: null,
            filter_column_name: "source",
            filter_column_type: "string"
          },
          {
            filter_value: ["callrail"],
            filter_condition: "and",
            filter_inclusion: "exclude",
            filter_comparison: null,
            filter_column_name: "source",
            filter_column_type: "string"
          },
          {
            filter_value: ["*referral*"],
            filter_condition: "and",
            filter_inclusion: "include",
            filter_comparison: null,
            filter_column_name: "medium",
            filter_column_type: "string"
          },
          {
            filter_value: ["*cpc*"],
            filter_condition: "or",
            filter_inclusion: "include",
            filter_comparison: null,
            filter_column_name: "medium",
            filter_column_type: "string"
          },
          {
            filter_value: ["*programmatic*"],
            filter_condition: "or",
            filter_inclusion: "include",
            filter_comparison: null,
            filter_column_name: "source",
            filter_column_type: "string"
          },
          {
            filter_value: ["*direct*"],
            filter_condition: "or",
            filter_inclusion: "include",
            filter_comparison: null,
            filter_column_name: "source",
            filter_column_type: "string"
          },
          {
            filter_value: ["*organic*"],
            filter_condition: "or",
            filter_inclusion: "include",
            filter_comparison: null,
            filter_column_name: "medium",
            filter_column_type: "string"
          }
        ],
        options: {
          records_amount: 5,
          default_sort_order: "DESC",
          default_sort_column: "sessions"
        },
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: true,
        sectionIds: [120],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      newUsers: {
        id: 889,
        title: "New Users",
        widget_titles: [],
        type: "NumberWidget",
        dashboard_id: "33",
        x: 1,
        y: 0,
        w: 1,
        h: 2,
        shared: false,
        filters: [],
        options: {},
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [120],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      totalLeads: {
        id: 890,
        title: "Lead Data",
        widget_titles: ["TOTAL LEADS","CONVERSION RATE"],
        type: "NumberWidget",
        dashboard_id: "33",
        x: 2,
        y: 0,
        w: 2,
        h: 2,
        shared: false,
        filters: [],
        options: {},
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [120],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      inventoryLevels: {
        id: 894,
        title: "Inventory Levels",
        widget_titles: ["NEW", "USED", "CERT."],
        type: "NumberWidget",
        dashboard_id: "33",
        x: 2,
        y: 6,
        w: 2,
        h: 3,
        shared: false,
        filters: [],
        options: {},
        owner_id: 9,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [120],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      funnelData: {
        id: 699,
        title: "The Funnel",
        widget_titles: [],
        type: "FunnelWidget",
        dashboard_id: "33",
        x: 0,
        y: 7,
        w: 2,
        h: 4,
        shared: true,
        filters: [],
        options: {},
        owner_id: 9,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [103, 120],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: true,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      accountSummary: {
        id: 908,
        title: 'Account Summary',
        widget_titles: [],
        type: 'GalleryWidget',
        dashboard_id: '33',
        x: 0,
        y: 16,
        w: 4,
        h: 4,
        shared: false,
        filters: [],
        options: {
          default_per_page: '5'
        },
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [
          120
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      leadBreakdown: {
        id: 892,
        title: 'Leads by Inventory Type',
        widget_titles: [
          'New',
          'Used',
          'Certified'
        ],
        type: 'DoughnutWidget',
        dashboard_id: '33',
        x: 2,
        y: 2,
        w: 2,
        h: 4,
        shared: false,
        filters: [],
        options: {},
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: true,
        sectionIds: [
          120
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      attribution: null,
      ppcStoreVisits: {
        id: 905,
        title: 'PPC Store Visits',
        widget_titles: [
          'PPC Store Visits'
        ],
        type: 'NumberWidget',
        dashboard_id: '33',
        x: 0,
        y: 20,
        w: 1,
        h: 2,
        shared: false,
        filters: [
          {
            filter_value: [
              '*In Store Visit*'
            ],
            filter_combine: null,
            filter_condition: null,
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'event_category',
            filter_column_type: 'string'
          },
          {
            filter_value: [
              'cpc'
            ],
            filter_combine: null,
            filter_condition: 'and',
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'medium',
            filter_column_type: 'string'
          },
          {
            filter_value: [
              '*facebook*'
            ],
            filter_combine: null,
            filter_condition: 'and',
            filter_inclusion: 'exclude',
            filter_comparison: null,
            filter_column_name: 'source',
            filter_column_type: 'string'
          }
        ],
        options: {},
        owner_id: 20,
        locked: false,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [
          120
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      prgStoreVisits: {
        id: 906,
        title: 'PRG Store Visits',
        widget_titles: ['PRG Store Visits'],
        type: 'NumberWidget',
        dashboard_id: '33',
        x: 1,
        y: 20,
        w: 1,
        h: 2,
        shared: false,
        filters: [
          {
            filter_value: [
              '*In Store Visit*'
            ],
            filter_combine: null,
            filter_condition: null,
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'event_category',
            filter_column_type: 'string'
          },
          {
            filter_value: [
              '*programmatic*'
            ],
            filter_combine: null,
            filter_condition: 'and',
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'source',
            filter_column_type: 'string'
          }
        ],
        options: {},
        owner_id: 20,
        locked: false,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [
          120
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      socialStoreVisits: {
        id: 907,
        title: 'Social Store Visits',
        widget_titles: ['Social Store Visits'],
        type: 'NumberWidget',
        dashboard_id: '33',
        x: 2,
        y: 20,
        w: 1,
        h: 2,
        shared: false,
        filters: [
          {
            filter_value: [
              '*In Store Visit*'
            ],
            filter_combine: null,
            filter_condition: null,
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'event_category',
            filter_column_type: 'string'
          },
          {
            filter_value: [
              '*facebook*'
            ],
            filter_combine: null,
            filter_condition: 'and',
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'source',
            filter_column_type: 'string'
          },
          {
            filter_value: [
              '*cpc*'
            ],
            filter_combine: null,
            filter_condition: 'and',
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'medium',
            filter_column_type: 'string'
          }
        ],
        options: {},
        owner_id: 20,
        locked: false,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [
          120
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      seoData: {
        id: 418,
        title: 'Organic Traffic',
        widget_titles: ['TOTAL SESSIONS', 'AVG SESSIONS DURATION'],
        type: 'NumberWidget',
        dashboard_id: '47',
        x: 0,
        y: 0,
        w: 2,
        h: 4,
        shared: false,
        filters: [
          {
            filter_value: [
              'organic'
            ],
            filter_condition: null,
            filter_column_name: 'medium'
          },
          {
            filter_value: [
              '*google*'
            ],
            filter_condition: 'and',
            filter_inclusion: 'include',
            filter_comparison: null,
            filter_column_name: 'source'
          }
        ],
        options: {},
        owner_id: 6,
        locked: false,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [
          67
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        hide_table_controls: false,
        hide_metric_label: false,
        moved: false
      },
      paidSocial: null,
      paidSocialNumbers: {
        id: 902,
        title: 'Paid Social Media',
        widget_titles: [],
        type: 'NumberWidget',
        dashboard_id: '33',
        x: 0,
        y: 14,
        w: 2,
        h: 2,
        shared: false,
        filters: [],
        options: {},
        owner_id: 20,
        locked: true,
        disableLegend: false,
        disableDataComparison: false,
        sectionIds: [
          120
        ],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        moved: false
      },
      topModels: {
        id: 901,
        title: 'Top Models',
        widget_titles: [],
        type: 'TableWidget',
        dashboard_id: '76',
        x: 2,
        y: 11,
        w: 2,
        h: 3,
        shared: false,
        filters: [],
        options: {
          default_per_page: '5'
        },
        owner_id: 12,
        locked: true,
        disableLegend: false,
        disableDataComparison: true,
        sectionIds: [],
        stacked_barchart: false,
        funnel_order: false,
        as_pyramid: false,
        click_through_section: null,
        click_through: false,
        hide_table_controls: false,
        hide_metric_label: false,
        moved: false
      },
      customData: [{
        id: 905,
        label: 'PPC Visits'
      },
      {
        id: 906,
        label: 'PRG Visits'
      },
      {
        id: 907,
        label: 'Social Visits'
      }]
    }
  },
  created () {
    this.$eventBus.$on('changeCurrentClient', () => {this.forceUpdateMethods()})
    this.$eventBus.$on('reloadWidgets', () => {this.forceUpdateMethods()})
    window.addEventListener('scroll', this.stickySidebar)
  },
  methods: {
    forceUpdateMethods () {
      this.customKey++
    },

    stickySidebar () {
      var el = document.getElementById('account-report')
      var ahr = document.getElementById('ahr-content')
      var elRect = el.getBoundingClientRect()
      var ahrRect = ahr.getBoundingClientRect()
      if (elRect.bottom > ahrRect.bottom + 5) {
        el.style.bottom = "80px"
      } else if (elRect.bottom < ahrRect.bottom - 5) {
        el.style.bottom = "50px"
      }
    }
  },
  mounted () {
    this.$root.$emit('customContent', true)
    this.$root.$on('customContent', () => {
      this.customKey++
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('changeCurrentClient')
    this.$eventBus.$off('reloadWidgets')
    this.$root.$emit('customContent', false)
    window.removeEventListener('scroll', this.stickySidebar)
  }
}
</script>

<style scoped>
</style>

<style>
#report-icon {
  max-width: 125px;
}
.ahr-icon {
  width: 40px;
  padding-bottom: 4px;
  display: inline-block;
}
#ahr-homepage #widgetppt888 .card-header {
  text-align: center;
}
#ahr-homepage .number-box {
  width: 100% !important;
  margin: 0 !important;
  background: none;
}
#ahr-homepage .custom-table .card-body {
  padding: 0 !important;
}
#ahr-homepage .custom-table .no-paddings.container-fluid,
#ahr-homepage .custom-table .nav,
#ahr-homepage .custom-table thead {
  display: none;
}

#ahr-homepage .fixedCardHeader {
  display: none;
}
#ahr-homepage .card-body {
  margin-top: 0;
}
#ahr-homepage .table-container {
  height: auto;
}

#ahr-homepage .custom-table tr {
 background: none;
}
#ahr-homepage .custom-table td {
 padding: 0 5px 5px 0;
 color: #3493B2;
 font-size: 12px;
}
#ahr-homepage .card {
  box-shadow: none;
}
#ahr-homepage .table {
  margin-bottom: 0;
}
#ahr-homepage h5,
#ahr-homepage h4, .number-box .h5 {
  color: #5d5f61;
  vertical-align: top;
  font-size: 14px;
  font-family: "Cooper Hewitt Semibold";
  letter-spacing: 2px;
  display: inline-block;
  margin: 8px 0;
}
#ahr-homepage .custom-table h5 {
  display: block;
}
#ahr-homepage .custom-table tbody {
  font-family: 'Cooper Hewitt Medium';
  letter-spacing: 2px;
  font-size: 14px;
}
#ahr-homepage #widgetppt894 .number-box {
  width: 33% !important;
}
#ahr-homepage #widgetppt890 .number-box {
  width: 50% !important;
}
.ahr-card {
  border-radius: 6px;
  -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
  margin: 10px 2px;
  padding: 10px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}
.col-sm-6 .ahr-card {
  height: 420px;
}
#account-report {
  background: #ECF6F9;
  padding: 15px;
  padding-top: 30px;
  text-align: center;
  color: #3493B2;
  position: fixed;
  max-width: 20%;
  left: 78%;
  top: 50px;
  bottom: 50px;
  border-radius: 6px;
  -webkit-transition: all 0.1s ease;
  -moz-transition: all 0.1s ease;
  -o-transition: all 0.1s ease;
  transition: all .1s ease;
}
#account-report h3 {
  font-family: "Cooper Hewitt Semibold";
  letter-spacing: 2px;
  font-size: 1.2rem;
  text-transform: uppercase;
}
#account-report .underline {
  height: 1px;
  width: 95%;
  background: #3493B2;
  display: block;
  margin: 15px auto;
}
#account-report .card {
  background: transparent;
  height: calc(100vh - 206px);
}
#ahr-content {
  /* background: #fff;
  border-radius: 6px;
  -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15); */
}
.transparent-bg {
  background: transparent;
}
#ahr-homepage #widgetppt892 canvas#doughnut-chart, #ahr-homepage #widgetppt892 .doughnut-chart {
  min-height: 200px !important;
}
#ahr-homepage #widgetppt890 {
  margin-bottom: 0;
}
#ahr-homepage .number-box {
  padding: 0 !important;
}
#ahr-homepage .custom-table #widgetppt901{
  padding-left: 40px;
  padding-right: 40px;
}
</style>